import { render } from "./SelectPrincipal.vue?vue&type=template&id=cd6f1dde&scoped=true"
import script from "./SelectPrincipal.vue?vue&type=script&lang=js"
export * from "./SelectPrincipal.vue?vue&type=script&lang=js"

import "./SelectPrincipal.vue?vue&type=style&index=0&id=cd6f1dde&lang=scss&scoped=true"
import "./SelectPrincipal.vue?vue&type=style&index=1&id=cd6f1dde&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd6f1dde"]])

export default __exports__